const notificationBadge = {
    bindings: {
      count: '='
    },
    template: `<span ng-if="$ctrl.count > 0" class="badge badge-assertive">{{ $ctrl.count }} </span>`
  };

export default notificationBadge;



/** WEBPACK FOOTER **
 ** ./src/app/directives/notifications/notificationBadge.js
 **/